export const LOOM_TYPE_REVERSE_MAP = {
  1: 'Power Loom',
  2: 'Sulzer',
  3: 'Air Jet',
  4: 'Water Jet',
  5: 'Open',
  6: 'Circular'
};

export const DELIVERY_TYPE = {
  LANDED: 1,
  X_FACTORY: 2,
  CNF: 3
};

export const LAST_MILE_DELIVERY_TYPE = {
  DEFAULT: 1,
  WAREHOUSE_SELF_PICKUP: 2
};

export const INVOICE_TYPE = {
  INVOICE: 1,
  E_INVOICE: 2
};

export const INVOICE_NATURE = {
  SINGLE: 1,
  MULTIPLE: 2
};

export const INVOICE_NATURE_LABELS = {
  [INVOICE_NATURE.SINGLE]: 'Single Invoice',
  [INVOICE_NATURE.MULTIPLE]: 'Multiple Invoices'
};

export const INVOICE_NATURE_OPTIONS = Object.entries(INVOICE_NATURE_LABELS).map(([id, label]) => ({
  id: Number(id),
  label
}));

export const DELIVERY_TYPE_REVERSE_MAP = {
  [DELIVERY_TYPE.LANDED]: 'Landed',
  [DELIVERY_TYPE.X_FACTORY]: 'x-Factory',
  [DELIVERY_TYPE.CNF]: 'CNF'
};

export const RUPEE = '₹';
export const DOLLAR = '$';

export const PRODUCTION_SUB_TYPE_REVERSE_MAP = {
  1: 'Greige',
  2: 'Yarn Dyed',
  3: 'RFD',
  4: 'Dyed',
  5: 'Printed',
  6: 'Denim'
};

export const PRODUCTION_SUB_TYPE_MAP = {
  GREIGE: 'Greige',
  YARN_DYED: 'Yarn Dyed',
  RFD: 'RFD',
  DYED: 'Dyed',
  PRINTED: 'Printed',
  DENIM: 'Denim'
};

export const PRODUCT_TYPE = {
  1: 'Running quality',
  2: 'Made to order'
};

export const HTTP_STATUS = {
  CONTINUE: 100,
  SWITCHING_PROTOCOLS: 101,
  PROCESSING: 102,
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  AMBIGUOUS: 300,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  TEMPORARY_REDIRECT: 307,
  PERMANENT_REDIRECT: 308,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  I_AM_A_TEAPOT: 418,
  UNPROCESSABLE_ENTITY: 422,
  FAILED_DEPENDENCY: 424,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505
};

export const UNITS = {
  KILOGRAMS: 1,
  METERS: 2,
  CENTIMETER: 3,
  INCH: 4,
  GRAMS: 5,
  PIECES: 6,
  GROSS: 7,
  YARDS: 8,
  POUNDS: 9
};

export const DEFAULT_FILE_SIZE = 5000000; // Bytes

export const EDIT_ORDER_WARNING_MESSAGE = {
  ALREADY_MARK_READY_DISPATCH:
    'The product has already been marked as ready by the supplier, you cannot edit the dispatch type now.',
  ALREADY_MARK_READY_QUANTITY:
    'The product has already been marked as ready by the supplier, you cannot edit the quantity now.',
  INVOICE_REQUESTED: 'The product invoice has been requested, you cannot edit the price now.',
  DIRECT_INVOICE: "Since it's a direct invoicing order, you cannot edit the price now.",
  BULK_DISPATCH_NOT_ALLOWED_ON_GOODS_READY:
    'The product has already been marked as ready by the supplier, you cannot edit the bulk dispatch now.',
  BULK_DISPATCH_NOT_ALLOWED_ON_DISABLED:
    'Bulk dispatch for this order has been disabled and cannot be enabled again.',
  DELIVERY_TYPE: 'Delivery type cannot be changed for this order.'
};

export const ORDER_TYPE = {
  GREIGE_RUNNING_QUALITY: 1,
  GREIGE_MADE_TO_ORDER: 2,
  YARN_DYED_RUNNING_QUALITY: 3,
  YARN_DYED_MADE_TO_ORDER: 4,
  FINISHED_FABRIC: 5,
  GREIGE_RUNNING_QUALITY_AND_JOB_WORK: 6,
  GREIGE_MADE_TO_ORDER_AND_JOB_WORK: 7,
  DENIM_RUNNING_QUALITY: 8,
  DENIM_MADE_TO_ORDER: 9
};

export const QUOTE_CATEGORY = {
  GREIGE: 1,
  JOB_WORK: 2,
  BUNDLED: 3,
  YARN_DYED: 4,
  DENIM: 5
};

export const UNITS_SHORT_NAME = {
  KILOGRAMS: 'kg',
  METERS: 'm',
  CENTIMETER: 'cm',
  INCH: 'in',
  GRAMS: 'g',
  PIECES: 'Piece',
  GROSS: 'gross',
  YARDS: 'yd',
  POUNDS: 'lb'
};

export const UNIT_CONVERSION_FACTORS = {
  METER_TO_YARD: 1.09361,
  KILOGRAM_TO_POUND: 2.20462,
  YARD_TO_METER: 0.9144,
  POUND_TO_KILOGRAM: 0.453592
};

export const DOMESTIC_CURRENCY_SYMBOL = '₹';

export const UNITS_REVERSED = {
  1: 'kg',
  2: 'm',
  3: 'cm',
  4: 'in',
  5: 'g',
  8: 'yd',
  9: 'lb',
  10: 'GSM',
  11: 'GLM',
  12: 'OZ'
};

export const DISCOUNTING_AT_SOURCE = 10;
export const DISCOUNTING_AT_WAREHOUSE = 20;
export const DISCOUNTING_SOURCE = [
  {
    value: DISCOUNTING_AT_SOURCE,
    label: 'At Source'
  },
  {
    value: DISCOUNTING_AT_WAREHOUSE,

    label: 'At Warehouse'
  }
];
export const PAYMENT_AT_BOOKING = 10;
export const PAYMENT_AT_DACC = 20;
export const PAYMENT_AT_DISPATCH = 30;
export const PAYMENT_AT_DELIVERY = 40;

export const PAYMENT_AT_OPTIONS = [
  {
    value: PAYMENT_AT_BOOKING,
    label: 'At Booking'
  },
  {
    value: PAYMENT_AT_DACC,
    label: ' At DACC'
  },
  {
    value: PAYMENT_AT_DISPATCH,
    label: 'At Dispatch'
  }
];
export const CREDIT_TYPE_OPEN = 10;
export const CREDIT_TYPE_PDC = 20;
export const CREDIT_TYPE_LC = 30;

export const CREDIT_TYPE_OPTIONS = [
  {
    value: CREDIT_TYPE_OPEN,
    label: 'Open Credit'
  },
  {
    value: CREDIT_TYPE_PDC,
    label: 'PDC Credit'
  },
  {
    value: CREDIT_TYPE_LC,
    label: 'LC'
  }
];
export const PAYMENT_REMAINING_AMOUNT = [
  {
    value: PAYMENT_AT_BOOKING,
    label: 'At Booking'
  },
  {
    value: PAYMENT_AT_DACC,
    label: ' At DACC'
  },
  {
    value: PAYMENT_AT_DISPATCH,
    label: 'At Dispatch'
  },
  {
    value: PAYMENT_AT_DELIVERY,
    label: 'At Delivery'
  }
];
export const DISCOUNTING_SOURCE_REVERSE = {
  DISCOUNTING_AT_SOURCE: 'At source',
  DISCOUNTING_AT_WAREHOUSE: 'At warehouse'
};
export const DEFAULT_ADVANCE_PERCENTAGE = 20;

export const ORDER_BOOKING_NEW_ORDER = 10;
export const ORDER_BOOKING_RE_PUNCHED_ORDER = 20;
export const ORDER_BOOKING_TYPES = [
  {
    value: ORDER_BOOKING_NEW_ORDER,
    label: 'New order'
  },
  {
    value: ORDER_BOOKING_RE_PUNCHED_ORDER,
    label: 'Re-punched order'
  }
];
export const ORDER_BOOKING_TYPES_REVERSE = {
  [ORDER_BOOKING_NEW_ORDER]: 'New order',
  [ORDER_BOOKING_RE_PUNCHED_ORDER]: 'Re-punched order'
};

export const RE_PUNCH_REASONS_ENUM = {
  CHANGE_IN_ORDER_SUMMARY: 10,
  PARTIAL_DELIVERY: 20,
  PARTIAL_PAYMENT: 30,
  PREVIOUS_LFB_SAME_CUSTOMER: 40,
  PREVIOUS_LFB_LEGIT_DATA: 50,
  OTHERS: 100
};

export const RE_PUNCH_REASONS_LABELS = {
  [RE_PUNCH_REASONS_ENUM.CHANGE_IN_ORDER_SUMMARY]: 'Change in order summary',
  [RE_PUNCH_REASONS_ENUM.PARTIAL_DELIVERY]: 'Partial delivery',
  [RE_PUNCH_REASONS_ENUM.PARTIAL_PAYMENT]: 'Partial payment',
  [RE_PUNCH_REASONS_ENUM.PREVIOUS_LFB_SAME_CUSTOMER]: 'Previous LFB - Same customer',
  [RE_PUNCH_REASONS_ENUM.PREVIOUS_LFB_LEGIT_DATA]: 'Previous LFB with legit data',
  [RE_PUNCH_REASONS_ENUM.OTHERS]: 'Others'
};

export const RE_PUNCH_REASONS = Object.entries(RE_PUNCH_REASONS_LABELS).map(([id, label]) => ({
  id: Number(id),
  label
}));

export const LEDGER_ACTION_ENUM = {
  ADD_PAYMENT: 20,
  INCREASE_CREDIT_LIMIT: 30,
  DECREASE_CREDIT_LIMIT: 40,
  ADD_CHARGES: 50,
  ADD_INVOICE: 60,
  ADD_CREDIT_NOTE: 70,
  ORDER_BOOKED: 80,
  ORDER_BOOKING_RELEASED: 85,
  INVOICE_DISBURSED: 90,
  ADD_TRANSFER_VOUCHER: 100
};

export const LEDGER_ACTION_OPTIONS = [
  { label: 'Add Invoice', value: LEDGER_ACTION_ENUM.ADD_INVOICE },
  { label: 'Add payment', value: LEDGER_ACTION_ENUM.ADD_PAYMENT },
  { label: 'Add credit note', value: LEDGER_ACTION_ENUM.ADD_CREDIT_NOTE },
  { label: 'Add charges', value: LEDGER_ACTION_ENUM.ADD_CHARGES },
  { label: 'Increase credit limit', value: LEDGER_ACTION_ENUM.INCREASE_CREDIT_LIMIT },
  { label: 'Decrease credit limit', value: LEDGER_ACTION_ENUM.DECREASE_CREDIT_LIMIT }
  // { label: 'Add transfer voucher', value: LEDGER_ACTION_ENUM.ADD_TRANSFER_VOUCHER }
];

export const LENDER_BLACKSOIL = 1;
export const LENDER_STRIDE = 2;
export const LENDER_LOCOFAST = 3;
export const LENDER_MUTHOOT_FINCORP = 4;
export const LENDER_121_FINANCE = 5;
export const LENDER_INDIFI = 6;
export const LENDER_BLACKSOIL_100 = 7;
export const LENDER_STRIDE_100 = 8;
export const LENDER_MINTIFI = 9;
export const LENDER_OXYZO = 10;

export const LENDER_NAMES = [
  {
    value: LENDER_BLACKSOIL,
    label: 'Blacksoil'
  },
  {
    value: LENDER_STRIDE,
    label: 'Stride'
  },
  {
    value: LENDER_MUTHOOT_FINCORP,
    label: 'Muthoot FinCorp Limited'
  },
  {
    value: LENDER_121_FINANCE,
    label: '121 Finance'
  },
  {
    value: LENDER_INDIFI,
    label: 'Indifi'
  },
  {
    value: LENDER_LOCOFAST,
    label: 'Locofast'
  },
  {
    value: LENDER_BLACKSOIL_100,
    label: 'Blacksoil 100%'
  },
  {
    value: LENDER_STRIDE_100,
    label: 'Stride 100%'
  },
  {
    value: LENDER_MINTIFI,
    label: 'Mintifi'
  },
  {
    value: LENDER_OXYZO,
    label: 'Oxyzo'
  }
];

export const LENDER_NAMES_REVERSE = {
  [LENDER_BLACKSOIL]: 'Blacksoil',
  [LENDER_STRIDE]: 'Stride',
  [LENDER_MUTHOOT_FINCORP]: 'Muthoot FinCorp Limited',
  [LENDER_121_FINANCE]: '121 Finance',
  [LENDER_INDIFI]: 'Indifi',
  [LENDER_LOCOFAST]: 'Locofast',
  [LENDER_BLACKSOIL_100]: 'Blacksoil 100%',
  [LENDER_STRIDE_100]: 'Stride 100%',
  [LENDER_MINTIFI]: 'Mintifi',
  [LENDER_OXYZO]: 'Oxyzo'
};

export const MODE_OF_PAYMENT_ENUM = {
  BANK_TRANSFER: 7,
  CHEQUE: 3,
  CREDIT_NOTE: 10,
  UPI: 2,
  OTHERS: 100
};

export const MODE_OF_PAYMENT_LABELS = {
  [MODE_OF_PAYMENT_ENUM.BANK_TRANSFER]: 'Bank Transfer',
  [MODE_OF_PAYMENT_ENUM.CHEQUE]: 'Cheque',
  [MODE_OF_PAYMENT_ENUM.CREDIT_NOTE]: 'Credit Note',
  [MODE_OF_PAYMENT_ENUM.UPI]: 'UPI',
  [MODE_OF_PAYMENT_ENUM.OTHERS]: 'Others'
};

export const MODE_OF_PAYMENT = Object.entries(MODE_OF_PAYMENT_LABELS).map(([id, label]) => ({
  id: Number(id),
  label
}));

export const INVOICE_CATEGORY_ENUM = {
  SAMPLE_INVOICE: 10,
  ORDER_INVOICE: 20,
  OTHER_CHARGES_INVOICE: 30
};

export const INVOICE_CATEGORY_LABELS = {
  [INVOICE_CATEGORY_ENUM.SAMPLE_INVOICE]: 'Sample invoice',
  [INVOICE_CATEGORY_ENUM.ORDER_INVOICE]: 'Order invoice',
  [INVOICE_CATEGORY_ENUM.OTHER_CHARGES_INVOICE]: 'Other charges invoice'
};

export const INVOICE_CATEGORY = Object.entries(INVOICE_CATEGORY_LABELS).map(([id, label]) => ({
  id: Number(id),
  label
}));

export const INVOICE_TYPE_ENUM = {
  INVOICE: INVOICE_TYPE.INVOICE,
  E_INVOICE: INVOICE_TYPE.E_INVOICE
};

export const INVOICE_TYPE_LABELS = {
  [INVOICE_TYPE_ENUM.INVOICE]: 'Invoice',
  [INVOICE_TYPE_ENUM.E_INVOICE]: 'e-Invoice'
};

export const INVOICE_TYPE_LEDGER = Object.entries(INVOICE_TYPE_LABELS).map(([id, label]) => ({
  id: Number(id),
  label
}));

export const CHARGES_TYPE_ENUM = {
  INTEREST_CHARGES: 10,
  PENAL_CHARGES: 20,
  OVERDUE_CHARGES: 30,
  CHEQUE_BOUNCE_CHARGES: 40,
  OTHERS: 100
};

export const CHARGES_TYPE_ENUM_REVERSE = {
  [CHARGES_TYPE_ENUM.INTEREST_CHARGES]: 'Interest charges',
  [CHARGES_TYPE_ENUM.PENAL_CHARGES]: 'Penal charges',
  [CHARGES_TYPE_ENUM.OVERDUE_CHARGES]: 'Overdue charges',
  [CHARGES_TYPE_ENUM.CHEQUE_BOUNCE_CHARGES]: 'Cheque bounce charges',
  [CHARGES_TYPE_ENUM.OTHERS]: 'Other charges'
};

export const CHARGES_TYPES = [
  { id: CHARGES_TYPE_ENUM.INTEREST_CHARGES, label: 'Interest charges' },
  { id: CHARGES_TYPE_ENUM.PENAL_CHARGES, label: 'Penal charges' },
  { id: CHARGES_TYPE_ENUM.OVERDUE_CHARGES, label: 'Overdue charges' },
  { id: CHARGES_TYPE_ENUM.CHEQUE_BOUNCE_CHARGES, label: 'Cheque bounce charges' },
  { id: CHARGES_TYPE_ENUM.OTHERS, label: 'Others' }
];

export const PAYMENT_DELAYED_ENUM = {
  NO: 0,
  YES: 1
};

export const PAYMENT_DELAYED = [
  { id: PAYMENT_DELAYED_ENUM.YES, label: 'Yes' },
  { id: PAYMENT_DELAYED_ENUM.NO, label: 'No' }
];

export const USER_PRODUCTION_TYPE = {
  GREIGE: 1,
  FINISHED_FABRIC: 2,
  DENIM: 3
};

export const USER_PRODUCTION_TYPE_REVERSE = {
  [USER_PRODUCTION_TYPE.GREIGE]: 'Greige',
  [USER_PRODUCTION_TYPE.FINISHED_FABRIC]: 'Processing',
  [USER_PRODUCTION_TYPE.DENIM]: 'Denim'
};

export const COMMISSION_CHARGE_UNITS = {
  YARDS: 8,
  LUMPSUM: 13
};

export const REVERSE_COMMISSION_CHARGE_UNITS = {
  8: 'yd',
  13: 'lumpsum'
};

export const COMMISSION_OPTIONS = Object.entries(REVERSE_COMMISSION_CHARGE_UNITS).map(
  ([value, label]) => ({
    value: Number(value),
    label
  })
);
